import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncateText',
})
export class TruncateTextPipe implements PipeTransform {
  transform(value: string, displayLength?: number): string {
    let result = value;

    if (displayLength == null || value == null) {
      return result;
    }

    // if the value is composed from more characters than displayLength
    if (value.length > displayLength) {
      result = `${value?.substring(0, displayLength)}...`;
    }

    const parts = value.split('\n');

    // if the value has more than 1 row
    if (parts.length > 1) {
      result = `${parts.join(' ')}...`;
    }

    return result;
  }
}
